import { IPromotionCode } from "../../redux/reducers/promotionCodes";
import { IReferralCode } from "../../redux/reducers/referralCodes";
import { getDiscountType, getUseType } from "../parsePromoCodeType";
import { getLocaleList, getIntlDateOptions, getIntlTimeOptions } from "../dateTimeFormatting";

export const amountSymbol = {
  Percent: (amount) => `${amount} %`,
  Value: (amount, currencySymbol = '£') => `${currencySymbol} ${amount}`,
};

export const localeList: string[] = getLocaleList();
export const dateOptions: Intl.DateTimeFormatOptions = getIntlDateOptions();
export const timeOptions: Intl.DateTimeFormatOptions = getIntlTimeOptions();

export const bottomText = (item: IPromotionCode | IReferralCode, currencySymbol = '£'): string => {
  let text = "";
  const { title, value }: any = getDiscountType(item.PromoCodeType || item.DiscountType);
  const useType = getUseType(item.PromoCodeType);
  const amount = value === "Percent" ? item.Percentage : +(item.Amount || 0) / 100;

  text += title;
  if (amount) {
    text += ` · ${amountSymbol[value as string](amount, currencySymbol)}`;
  }

  if (item?.MinimumSpend) {
    text += " · ";
text += item.MinimumSpend ? `Min Spend ${currencySymbol}${item.MinimumSpend / 100}` : ``;
  }

  if (useType?.title) {
    text += " · " + useType?.title;
  }

  if (item?.FirstName && item?.LastName && item?.Email) {
    text += ` · User: ${item.FirstName} ${item.LastName} (${item.Email})`;
  }

  if (item?.StartDate) {
    text += ` · Valid ${new Date(item.StartDate).toLocaleDateString(
      localeList,
      dateOptions
    )} 
    to ${new Date(item.Expires).toLocaleDateString(localeList, dateOptions)}`;
  }

  return text;
};
